<template>
    <div>
      <div class="lightbox-target" :class="{'show' : IsViewImage}" @click.self="closeImage()">
        <div class="main-image-container" >
          <img :src="ActiveImageSrc" class="main-image-view" @error="setPrebuildThumbnail($event)"/>
          <a class="lightbox-close" @click.stop="closeImage()" href="javascript:void(0)"></a>
        </div>
        <div class="container d-flex justify-content-center other-image-container" id="popup-thumb-slider">
          <div class="popup-thumb-slider-action" v-if="is_display_action" @click="showPrevSlide"><i class="fa fa-chevron-left"></i></div>
          <div class="popup-thumb-slide" :style="{width : `${slideContainerWidth}px`}">
            <div id="popup-thumb-container" ref="popupThumbSlide" :style="dy_slider_style">
              <div v-for="(PI, index) in ProductImages" :key="index" class="popup-si-container" @error="setPrebuildThumbnail($event)" :class="{'active' : index === ActiveImageIndex}">
                <img :src="PI.image_base_path+PI.path" alt="" @click="ActiveImage(index)">
              </div>
              <div class="popup-si-container" :key="ProductImages.length" :class="{'active' : ProductImages.length === ActiveImageIndex}" v-if="euTyreLabelImageSrc != ''">
                <img :src="euTyreLabelImageSrc" ref="EuTyreLabelImage" alt="EuTyreLabelImage" @click="ActiveImage(ProductImages.length);">
              </div>
            </div>
          </div>
          <div class="popup-thumb-slider-action" v-if="is_display_action" @click="showNextSlide"><i class="fa fa-chevron-right"></i></div>
        </div>
      </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

  export default {
    name : "ViewImageInPopup",
    props : {
      ProductImages : {default : () => []},
      euTyreLabelImageSrc : {}
    },
    computed : {
      ...mapGetters('view_image_pd', ["IsViewImage", "ActiveImageIndex"]),
      is_display_action() {
        return (this.ProductImages.length + (this.euTyreLabelImageSrc != '' ? 1 : 0)) > (this.slideContainerWidth / this.slideWidth)
      }
    },
    watch : {
      ActiveImageIndex : {
        handler() {
          this.setActiveImageSrc()
        }
      },
      ProductImages : {
        handler() {
          this.setActiveImageSrc()
        }
      },
      IsViewImage : {
        handler(newVal) {
          if (newVal === true) {
            this.setActiveImageSrc()
            this.doImageInMiddle()
          }
        }
      }
    },
    created() {
      this.setActiveImageSrc()
    },
    data() {
      return {
        ActiveImageSrc : '',
        slideWidth: 110,
        slideContainerWidth : 1210,
        ActiveIndex : 0,
        window_inner_width : window.innerWidth,
        dy_slider_style : {}
      }
    },
    mounted() {
      this.doResponsive()
      var that = this;
      window.addEventListener('resize', function() {
        that.doResponsive()
      })
    },
    methods : {
      ...mapActions("view_image_pd", ["setImageView", "setActiveImageIndex"]),
      setActiveImageSrc() {
        if (this.ProductImages.length > this.ActiveImageIndex) {
            const CurrentImage = this.ProductImages[this.ActiveImageIndex];
            this.ActiveImageSrc = CurrentImage.image_base_path+CurrentImage.path
        } else {
          const EuTyreLabelImage = this.$refs.EuTyreLabelImage
          if (EuTyreLabelImage) {
            this.ActiveImageSrc = EuTyreLabelImage.getAttribute("src")
          }
        }
      },
      closeImage() {
        this.setImageView(false);
      },
      ActiveImage(index) {
        this.setActiveImageIndex(index);
      },
      setEuLabelImageSrc(event) {
        this.ActiveImageSrc = event.target.getAttribute("src");
      },
      showSlide() {
        const translateValue = -this.ActiveIndex * (this.slideWidth) + 'px';
        this.$refs.popupThumbSlide.style.transform = 'translateX(' + translateValue + ')';
      },
      showNextSlide() {
        if (this.ActiveIndex < this.ProductImages.length - ((this.slideContainerWidth / this.slideWidth) - 1)) {
          this.ActiveIndex++;
          this.showSlide();
        } else {
          this.ActiveIndex = 0;
          this.showSlide();
        }
      },
      showPrevSlide() {
        if (this.ActiveIndex > 0) {
          this.ActiveIndex--;
          this.showSlide();
        }
      },
      doResponsive() {
        this.window_inner_width = window.innerWidth;

        if (this.window_inner_width >= 1210) {
          this.slideContainerWidth = 990
        } else if (this.window_inner_width >= 990) {
          this.slideContainerWidth = 770
        } else if (this.window_inner_width >= 770) {
          this.slideContainerWidth = 550
        } else if (this.window_inner_width >= 550) {
          this.slideContainerWidth = 330
        } else if (this.window_inner_width >= 330) {
          this.slideContainerWidth = 110
          this.slideWidth = 110
        } else {
          this.slideContainerWidth = 110
          this.slideWidth = 110
        }
        //this.showSlide();
        this.doImageInMiddle();
      },
      doImageInMiddle() {

        if (this.is_display_action) {
          var total_slide = this.slideContainerWidth / this.slideWidth;
          var middle_position = (total_slide - 1) / 2;
          var clicked_image_index = this.ActiveImageIndex;
          if (clicked_image_index > middle_position) {
            this.ActiveIndex = clicked_image_index - middle_position;
          } else {
            this.ActiveIndex = clicked_image_index;
          }
          const translateValue = -this.ActiveIndex * (this.slideWidth) + 'px';
          this.dy_slider_style = {transform: 'translateX(' + translateValue + ')'};
        } else {
          this.dy_slider_style = { justifyContent : 'center' };
        }
      }

    }
  }
</script>

<style>


/* Styles the lightbox, removes it from sight and adds the fade-in transition */

.lightbox-target {
  position: fixed;
  top: -100%;
  width: 100%;
  opacity: 0;
  -webkit-transition: opacity .5s ease-in-out;
  -moz-transition: opacity .5s ease-in-out;
  -o-transition: opacity .5s ease-in-out;
  transition: opacity .5s ease-in-out;
  overflow: hidden;

  display: flex;
  align-items: start;
  justify-content: center;
  height: 100vh; /* Adjust as needed */
  background-color: rgba(0,0,0,0.7);
  padding-top:1.5rem ;
}

/* Styles the lightbox image, centers it vertically and horizontally, adds the zoom-in transition and makes it responsive using a combination of margin and absolute positioning */
.main-image-container {
  width: 60%; /* Adjust as needed */
  max-width: 600px; /* Set a maximum width if desired */
  padding: 5px;
  background-color: #fff;
  border: 1px solid #ccc;
  text-align: center;
  position: relative;
}

@media (max-width: 768px) {
  .main-image-container {
    width: 80%; /* Adjust as needed */
    max-width: 600px; /* Set a maximum width if desired */
  }
}

.lightbox-target img.main-image-view {
  margin: auto;
  max-height: 0%;
  max-width: 0%;
  border: 3px solid white;
  /*box-shadow: 0px 0px 8px rgba(0,0,0,.3);*/
  box-sizing: border-box;
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;

}

/* Styles the close link, adds the slide down transition */

a.lightbox-close {
  display: block;
  width:30px;
  height:30px;
  border: 1px solid #fff;
  border-radius: 15px;
  box-sizing: border-box;
  background: black;
  color: white;
  text-decoration: none;
  position: absolute;
  top: -15px;
  right: -15px;
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
}

/* Provides part of the "X" to eliminate an image from the close link */

a.lightbox-close:before {
  content: "";
  display: block;
  height: 20px;
  width: 3px;
  background: #fff;
  position: absolute;
  left: 13px;
  top:4px;
  -webkit-transform:rotate(45deg);
  -moz-transform:rotate(45deg);
  -o-transform:rotate(45deg);
  transform:rotate(45deg);
}

/* Provides part of the "X" to eliminate an image from the close link */

a.lightbox-close:after {
  content: "";
  display: block;
  height: 20px;
  width: 3px;
  background: #fff;
  position: absolute;
  left: 13px;
  top:4px;
  -webkit-transform:rotate(-45deg);
  -moz-transform:rotate(-45deg);
  -o-transform:rotate(-45deg);
  transform:rotate(-45deg);
}

/* Uses the :target pseudo-class to perform the animations upon clicking the .lightbox-target anchor */

.lightbox-target.show {
  opacity: 1;
  top: 0;
  bottom: 0;
  overflow:hidden;
  z-index: 111111;
}

.lightbox-target.show img.main-image-view {
  max-height: 90%;
  max-width: 90%;
}

/*--Slider CSS--*/

#popup-thumb-slider {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  position: absolute;
  bottom:0;
  left: 0;
  right: 0;
  margin: auto;
  cursor: pointer;
}

#popup-thumb-slider .popup-thumb-slider-action {
  cursor: pointer;
  color: #ffffff;
  transition: transform 0.3s ease-in-out;
}

#popup-thumb-slider .popup-thumb-slider-action:hover {
  transform: scale(1.02);
}

.popup-thumb-slide {
  overflow-x: hidden;
  margin: 0 .5rem;
}

#popup-thumb-container {
  display: flex;
  transition: transform 0.5s ease-in-out;
  max-width: 100%;
  margin: .5rem auto;
}
#popup-thumb-container .popup-si-container {
  width: 100px;
  height: 100px;
  border: 1px solid #CCCCCC;
  justify-content: center;
  display: flex;
  background: #ffffff;
  position: relative;
  overflow: hidden;
  flex: 0 0 100px;
  box-sizing: border-box;
  margin-right: 10px;
}
#popup-thumb-container .popup-si-container.active,  #popup-thumb-container .popup-si-container:hover{
  box-shadow: 0px 0px 10px rgba(255,255,255,0.5);
  transform: scaleY(1.1);
}

#popup-thumb-container .popup-si-container img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 100%;
  max-height: 100%;
  transition: transform 0.3s ease-in-out;
}

/*@media (max-width: 400px) {
  .popup-thumb-slide {
    width: 100px;
  }

  #popup-thumb-container .popup-si-container {
    margin-right: 0 !important;
  }
}*/
</style>